"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonLatinBasedLanguage = exports.isInternationalLocalization = exports.isInternationalLocalizationFamily = exports.languageCodeFromString = exports.isCartoonsAdditionalLanguageCode = exports.isLanguageCode = exports.isFullLanguageCode = exports.supportedLanguageCodes = exports.nonLatinBasedLanguages = exports.cartoonsAdditionalLanguageCodes = exports.redbullComAdditionalLanguageCodes = exports.rbtvAdditionalLanguageCodes = void 0;
const authorization_model_1 = require("./authorization.model");
exports.rbtvAdditionalLanguageCodes = ['en-EU'];
exports.redbullComAdditionalLanguageCodes = [
    'en-EU',
    'en-MT',
    'he-IL',
    'is-IS',
    'ka-GE',
    'sr-ME',
    'ru-UZ',
    'es-DO',
];
exports.cartoonsAdditionalLanguageCodes = [
    'ar-BH',
    'ar-DZ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-TN',
    'el-CY',
    'en-EG',
    'en-HK',
    'en-JM',
    'en-KW',
    'en-LK',
    'en-MT',
    'en-MV',
    'en-NA',
    'en-OM',
    'es-BO',
    'es-CR',
    'es-DO',
    'es-PA',
    'fr-MU',
    'fr-SN',
    'he-IL',
    'is-IS',
    'ka-GE',
    'pt-AO',
    'ru-BY',
    'ru-UZ',
    'sq-KV',
    'sv-SE',
];
exports.nonLatinBasedLanguages = [
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-MA',
    'ar-MEA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-TN',
    'az-AZ',
    'bg-BG',
    'el-CY',
    'el-GR',
    'he-IL',
    'hi-IN',
    'ja-JP',
    'ka-GE',
    'ko-KR',
    'mk-MK',
    'ru-BY',
    'ru-KZ',
    'ru-RU',
    'ru-UZ',
    'sr-RS',
    'th-TH',
    'uk-UA',
    'zh-CN',
    'zh-HK',
    'zh-TW',
];
exports.supportedLanguageCodes = Object.keys(authorization_model_1.userAuthorizationSettings.mappings.locales);
const isFullLanguageCode = (str) => {
    const pattern = /^[a-z]{2}-[A-Z]{2,3}$/;
    return pattern.test(str);
};
exports.isFullLanguageCode = isFullLanguageCode;
const isLanguageCode = (v) => exports.supportedLanguageCodes.includes(v);
exports.isLanguageCode = isLanguageCode;
const isCartoonsAdditionalLanguageCode = (languageCode) => {
    return exports.cartoonsAdditionalLanguageCodes.includes(languageCode);
};
exports.isCartoonsAdditionalLanguageCode = isCartoonsAdditionalLanguageCode;
const languageCodeFromString = (v) => {
    if ((0, exports.isLanguageCode)(v)) {
        return v;
    }
    throw Error(`'${v}' is not a valid language code`);
};
exports.languageCodeFromString = languageCodeFromString;
const isInternationalLocalizationFamily = (languageCode) => {
    return languageCode.length === 2;
};
exports.isInternationalLocalizationFamily = isInternationalLocalizationFamily;
const isInternationalLocalization = (languageCode) => {
    return languageCode.endsWith('-INT');
};
exports.isInternationalLocalization = isInternationalLocalization;
const isNonLatinBasedLanguage = (languageCode) => {
    return exports.nonLatinBasedLanguages.includes(languageCode);
};
exports.isNonLatinBasedLanguage = isNonLatinBasedLanguage;
//# sourceMappingURL=data:application/json;base64,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